import { sizeChoices } from './displayOptions';
import { fieldNames } from '../fields';

export const dataModel = {
    component: String(),
    id: String(),
    title: String(),
    titleSize: sizeChoices,
    description: String(),
    descriptionSize: sizeChoices
};

export const defaults = {
    component: fieldNames.title,
    titleSize: sizeChoices.h4.value,
    descriptionSize: sizeChoices.body1.value
};
